import React, { useContext, useEffect, useState } from "react";
import { Typography } from "antd";
import { useFetchApi } from "../../../../../../hooks/useFetchApi";
import { flattenMetrics } from "../../../../../../helper";
import { StateContext } from "../../../../../../store/context";
import { StatisticsTable } from "../components/StatisticTable";
import { FormatButtons, FormatConfig } from "../components/FormatButtons";

const { Title } = Typography;

interface StatisticsProps {
  selectedStock?: any;
}

const INCLUDED_METRIC_NAMES = [
  "total_number_of_issued_shares",
  "Price to Earnings Ratio",
  "Price to Book Ratio",
  "EBITDA Margin %",
  "Return on Asset",
  "Return on Equity",
  "Gross Profit Margin %",
  "Net Profit Margin %",
  "EBITDA Margin %",
  "Quick Ratio",
  "Current Assets Ratio",
  "Revenue per Share",
  "Free Cash Flow per Share",
];

export const Statistics: React.FC<StatisticsProps> = ({ selectedStock }) => {
  const {
    response: metricsAndEquations,
    loading: metricsAndEquationsLoading,
    execute: getMetricsAndEquations,
  } = useFetchApi("/api/metrics-and-equations", {}, "GET");

  const {
    execute: generateGraphs,
    loading: graphLoading,
    response: graphData,
  } = useFetchApi("/api/dynamic-graph");

  const { baseCurrency, authUser } = useContext(StateContext);

  const [metricsData, setMetricsData] = useState<any>(null);
  // No decimal selected keeps the values as the API returns them; issued
  // shares were always shown in millions.
  const [formatConfig, setFormatConfig] = useState<FormatConfig>({
    decimal: "",
    scale: "millions",
  });

  const flattenedMetrics = metricsData
    ? flattenMetrics(metricsData).filter((metric: any) =>
        INCLUDED_METRIC_NAMES.includes(metric.name?.trim()),
      )
    : [];

  const payload = {
    baseCurrency: baseCurrency,
    filter: "annually",
    period: "5",
    selectedMetrics: flattenedMetrics,
    selectedStocks: [...(selectedStock?.id ? [selectedStock] : [])],
    // Show split-adjusted values for these computed metrics.
    splitAdjustedMetrics: ["Revenue per Share"],
  };

  useEffect(() => {
    getMetricsAndEquations();
  }, []);

  useEffect(() => {
    if (metricsAndEquations && !metricsAndEquationsLoading) {
      setMetricsData(metricsAndEquations);
    }
  }, [metricsAndEquations, metricsAndEquationsLoading]);

  useEffect(() => {
    if (!selectedStock?.id || !metricsData) return;
    generateGraphs(payload);
  }, [selectedStock, metricsData]);

  console.log("graphData: ", graphData);

  return (
    <div className="vi-glass-card p-6">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <Title level={5} style={{ margin: 0 }}>
          Statistics
        </Title>
        <FormatButtons
          formatConfig={formatConfig}
          onFormatChange={setFormatConfig}
        />
      </div>
      <StatisticsTable
        data={graphData}
        loading={graphLoading}
        formatConfig={formatConfig}
      />
    </div>
  );
};
